import strings from 'utils/strings'
import {
  POWER_NET_LEVELS_MAPPING,
  KEEP_AWAKE_MAPPING,
  PWM_MODES_MAPPING,
} from 'constants/featureOutputs'
import {
  CAN,
  SERVICE,
  PIN,
  IGNITION,
  AUTOMATIC,
  AH,
  AL,
  PWM,
} from 'utils/constants'

import { mapFrom } from 'utils/functional'
import { parseHmsNumbers } from 'utils/timers'

export const powerNetLevels = mapFrom({
  [POWER_NET_LEVELS_MAPPING.FIRST_GROUP]: strings.pnl_first_group,
  [POWER_NET_LEVELS_MAPPING.SECOND_GROUP]: strings.pnl_second_group,
  [POWER_NET_LEVELS_MAPPING.THIRD_GROUP]: strings.pnl_third_group,
  [POWER_NET_LEVELS_MAPPING.LAST_GROUP]: strings.pnl_last_group,
})

export const outputTypeLabels = {
  [SERVICE]: strings.native,
  [PIN]: strings.output_type_PIN,
  [CAN]: strings.can,
}

export const polarityLabels = {
  [AH]: strings.high_side,
  [AL]: strings.low_side,
  [PWM]: strings.pwm,
}

export const resetLabels = {
  [IGNITION]: strings.ignition,
  [AUTOMATIC]: strings.automatic,
}

export const resetLabelsFuse = {
  [IGNITION]: strings.ignition,
  [AUTOMATIC]: strings.automatic,
}

export const keepAwakeLabel = mapFrom({
  [KEEP_AWAKE_MAPPING.ON]: strings.on,
  [KEEP_AWAKE_MAPPING.OFF]: strings.off,
})

export const virtualFuseMask = (value) =>
  value && `${value.toFixed(1)}${strings.amps_a}`

export const virtualFuseReset = (
  type,
  attempts,
  resetDelay,
  longform = false
) => {
  if (longform === false) return resetLabelsFuse[type]

  if (type === AUTOMATIC) {
    const withAttempts = `${resetLabelsFuse[type]}, ${attempts} ${strings.attempts_lowercase}`
    const { minutes, seconds } = parseHmsNumbers(resetDelay)
    const resetDelayString = strings.timer_value(0, minutes, seconds)
    return `${withAttempts}, ${strings.every} ${resetDelayString}`
  }

  if (type === IGNITION) {
    return strings.on_ignition
  }
}

export const pwmModeTitle = mapFrom({
  [PWM_MODES_MAPPING.FIXED_DUTY_CYCLE_AND_FREQUENCY]:
    strings.fixed_duty_cycle_and_frequency,
  [PWM_MODES_MAPPING.VARIABLE_DUTY_CYCLE]: strings.variable_duty_cycle,
  [PWM_MODES_MAPPING.VARIABLE_FREQUENCY]: strings.variable_frequency,
})
